import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAvaluosRequest, getAvaluoRequest, sendAvaluoRequest } from '../../actions';
import Avaluo from '../../components/Avaluo';

const AvaluoContainer = () => {
  const dispatch = useDispatch();

  const { avaluos } = useSelector(state => ({
    avaluos: state.avaluos
  }));

  const fetchAvaluos = (properties = {}) => {
    dispatch(fetchAvaluosRequest(properties));
  }

  const getAvaluo = (properties = {}) => {
    dispatch(getAvaluoRequest(properties));
  }

  const sendAvaluo = (properties = {}, personalInfo = {}) => {
    dispatch(sendAvaluoRequest(personalInfo, properties));
  };

  return <Avaluo 
    fetchAvaluos={fetchAvaluos} 
    getAvaluo={getAvaluo} 
    avaluos={avaluos} 
    sendAvaluo={sendAvaluo} 
  />
};

export default AvaluoContainer
